import React from 'react';
import StatusBadge from '../../Components/StatusBadge';
import { useNova } from '../NovaContext';
import { STATUS_LABEL } from '../constants';
import { IconMinus, IconX } from '../icons';
import Logo from './Logo';
import { Title } from './Text';

export default function PanelHeader() {
    const { state, status, actions } = useNova();

    return (
        <header className="nova_header">
            <div className="nova_brand">
                <Logo size="lg" animate busy={state.sending} />
                <div className="nova_brand_line">
                    <Title as="h2" size="lg" className="nova_name">Foresee</Title>
                    <StatusBadge color="var(--color-text-inverse)" appearance="outline" dot={false} transform="none">AI</StatusBadge>
                </div>
            </div>
            <div className="nova_header_actions">
                {status !== 'online' && (
                    <StatusBadge variant={status === 'connecting' ? 'warning' : 'neutral'} pulse={status === 'connecting'} className="nova_status">
                        {STATUS_LABEL[status]}
                    </StatusBadge>
                )}
                <button type="button" className="nova_icon_btn nova_icon_btn--header" aria-label="Minimize Foresee AI assistant" onClick={actions.minimize}>
                    <IconMinus size={18} />
                </button>
                <button type="button" className="nova_icon_btn nova_icon_btn--header" aria-label="Close Foresee AI assistant" onClick={actions.close}>
                    <IconX size={18} />
                </button>
            </div>
        </header>
    );
}
